import React, {ReactElement} from 'react';

import {FloatingPlacement, FloatingInteraction} from 'ui-library/floating-ui/FloatingConstants';
import Popover from 'ui-library/floating-ui/Popover';

function MergeDuplicatePopoverContent(): JSX.Element {
  return (
    <div>
      <p>
        When you try to register entities that conflict with existing entities in the registry, Benchling can
        merge the incoming duplicates into the matching registered entities.
      </p>
      <p>
        {'For detailed information on what actions are performed in a merge, see this '}
        <a
          rel="noopener noreferrer"
          target="_blank"
          href="https://help.benchling.com/hc/articles/9684256435597"
        >
          help article
        </a>
        .
      </p>
    </div>
  );
}

interface Props {
  children: React.ReactNode;
}

export default function MergeDuplicatePopover(props: Props): ReactElement {
  return (
    <span className="u-tiny-padding-right">
      <Popover
        title="Merging duplicate entities into the Registry"
        renderContent={() => <MergeDuplicatePopoverContent />}
        placement={FloatingPlacement.RIGHT}
        interaction={FloatingInteraction.CLICK}
      >
        <>{props.children}</>
      </Popover>
    </span>
  );
}
